import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_YELLOW,
    codeProp: 'bfNo',
    detailUrl: '/BfDetail',
    detailIdProp: 'bfId',
    listUrl: '/BfList',
    mapProp: 'bfMap',
    name: '业务流程',
    textProp: 'bfName',
    type: 'BF',
}
